import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "edit",
  props: ["commData"],
  data: function data() {
    var checkNumber = function checkNumber(rule, value, callback) {
      if (!isNaN(Number(value))) {
        callback();
      } else {
        callback(new Error("请输入正确的数值"));
      }
    };

    return {
      editShow: false,
      baudrateList: ["115200", "57600", "38400", "19200", "9600", "4800", "2400", "1800", "1200", "600", "300", "200", "150", "134", "110"],
      dataBitsList: ["6", "7", "8"],
      dataBitsInputShow: false,
      dataBitsInputValue: "",
      stopBitsList: ["1", "2"],
      stopBitsInputShow: false,
      stopBitsInputValue: "",
      rules: {
        timeout: [{
          required: true,
          message: "请输入分包间隔",
          trigger: "blur"
        }, {
          validator: checkNumber,
          trigger: "blur"
        }],
        frame_len: [{
          required: true,
          message: "请输入分包长度",
          trigger: "blur"
        }, {
          validator: checkNumber,
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    dataBitsChange: function dataBitsChange(e) {
      // console.log(e);
      if (!e) {
        this.dataBitsInputShow = true;
      }
    },
    stopBitsChange: function stopBitsChange(e) {
      if (!e) {
        this.dataBitsInputShow = true;
      }
    },
    dataBitsInputBlur: function dataBitsInputBlur() {
      if (this.dataBitsList.includes(this.dataBitsInputValue)) {
        this.dataBitsInputShow = false;
        this.commData.data_bits = this.dataBitsInputValue;
        this.dataBitsInputValue = "";
      } else {
        this.dataBitsList.push(this.dataBitsInputValue);
        this.dataBitsInputShow = false;
        this.commData.data_bits = this.dataBitsInputValue;
        this.dataBitsInputValue = "";
      }
    },
    stopBitsInputBlur: function stopBitsInputBlur() {
      if (this.dataBitsList.includes(this.stopBitsInputValue)) {
        this.stopBitsInputShow = false;
        this.commData.stop_bits = this.stopBitsInputValue;
        this.stopBitsInputValue = "";
      } else {
        this.dataBitsList.push(this.stopBitsInputValue);
        this.stopBitsInputShow = false;
        this.commData.stop_bits = this.stopBitsInputValue;
        this.stopBitsInputValue = "";
      }
    },
    confirm: function confirm() {
      var _this = this;

      this.$refs["editform"].validate(function (v) {
        if (v) {
          _this.editShow = false;
        } else {
          _this.$message({
            type: "warning",
            message: "请先完善表单"
          });
        }
      });
    }
  }
};